import { useRouter } from "next/router";

import useStyles from "_styles/pages/blogs/blogs.js";

import HomePage from "./homePage.js";
import Layout   from "./layout.js";

const blogs = ( { data } ) => {
	const { classes }            = useStyles ( undefined, { name: "styles" } );
	const { query:{ category } } = useRouter ();

	return (
		<div className = { classes.blogContainer }>

			<Layout
				categories       = { data }
				selectedCategory = { category }

			>
				<HomePage
					categories = { data }
				/>
			</Layout>
		</div>
	);
};

export default blogs;
